/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Pipe, PipeTransform} from '@angular/core';

import {formatIsoCurrency, stringToCurrency} from '../../../components/util/iso-currency-format';
import {AppLocaleService} from '../locale/app-locale.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Pipe({standalone: true, name: 'isoCurrency'})
export class IsoCurrencyPipe implements PipeTransform {
  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly appLocale: AppLocaleService
  ) {
  }

  transform(amount: any, currencyCode?: string, fraction?: number, hideCurrency?: boolean, hideExtras?: boolean): any {
    return formatIsoCurrency(
      amount,
      currencyCode,
      fraction,
      hideCurrency,
      hideExtras,
      this.LocalNetworkProfile.get('defaultCurrency'),
      this.appLocale.getLocaleId()
    );
  }
}

@Pipe({standalone: true, name: 'stringToCurrency'})
export class StringToCurrencyPipe implements PipeTransform {
  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly appLocale: AppLocaleService
  ) {
  }

  transform(value: any): any {
    return stringToCurrency(value, this.LocalNetworkProfile.get('defaultCurrency'), this.appLocale.getLocaleId());
  }
}
